import api from '../services/api'

export default {
  namespaced: true,
  actions: {
    getItems ({ commit }, payload) {
      return api.getItems({ ...payload, expand: 'organization,user' })
        .then(response => ({
          items: response.data.items,
          totalCount: response.data.count
        }))
    },
    getRaw ({ commit }, payload) {
      return api.getItems(payload)
    },
  },
}
